import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × SÉZANE: Retro grace and system logic
// Floral grids, soft serif typography, textile-like pattern
export function VasarelySezaneMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <defs>
        <linearGradient id="sezane-vintage" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#FFF8F0" />
          <stop offset="50%" stopColor="#F5E8DC" />
          <stop offset="100%" stopColor="#E8D5C4" />
        </linearGradient>
        <pattern id="sezane-lace" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
          <circle cx="10" cy="10" r="2" fill="#D4A5A5" opacity="0.3" />
          <circle cx="0" cy="0" r="1" fill="#D4A5A5" opacity="0.2" />
          <circle cx="20" cy="0" r="1" fill="#D4A5A5" opacity="0.2" />
          <circle cx="0" cy="20" r="1" fill="#D4A5A5" opacity="0.2" />
          <circle cx="20" cy="20" r="1" fill="#D4A5A5" opacity="0.2" />
        </pattern>
      </defs>

      {/* Vintage cream background */}
      <rect x="0" y="0" width="794" height="1123" fill="url(#sezane-vintage)" />

      <g transform="translate(397 540)">
        {/* Textile-like pattern overlay */}
        <rect x="-397" y="-540" width="794" height="1123" fill="url(#sezane-lace)" />

        {/* Floral grid structure */}
        {Array.from({ length: 8 }).map((_, i) =>
          Array.from({ length: 10 }).map((_, j) => {
            const x = (i - 3.5) * 90;
            const y = (j - 4.5) * 100;
            
            return (
              <g key={`${i}-${j}`} transform={`translate(${x} ${y})`}>
                {/* Stylized flower as grid node */}
                <circle cx="0" cy="0" r="20" fill="none" stroke="#D4A5A5" strokeWidth="1" opacity="0.4" />
                {[0, 72, 144, 216, 288].map((angle) => {
                  const rad = (angle * Math.PI) / 180;
                  return (
                    <circle
                      key={angle}
                      cx={Math.cos(rad) * 15}
                      cy={Math.sin(rad) * 15}
                      r="6"
                      fill="#C99090"
                      opacity="0.3"
                    />
                  );
                })}
                <circle cx="0" cy="0" r="5" fill="#B88080" opacity="0.5" />
              </g>
            );
          })
        )}

        {/* Lace and lattices */}
        {Array.from({ length: 12 }).map((_, i) => {
          const r = 50 + i * 22;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke="#D4A5A5"
              strokeWidth="1"
              opacity={0.25 - i * 0.018}
              strokeDasharray="4 4"
            />
          );
        })}

        {/* Retro geometric lattice */}
        {Array.from({ length: 8 }).map((_, i) => {
          const angle = (i * Math.PI) / 4;
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(angle) * 260}
              y2={Math.sin(angle) * 260}
              stroke="#C99090"
              strokeWidth="1"
              opacity="0.15"
            />
          );
        })}

        {/* Central vintage medallion */}
        <circle cx="0" cy="0" r="90" fill="none" stroke="#B88080" strokeWidth="2" opacity="0.4" />
        <circle cx="0" cy="0" r="70" fill="none" stroke="#D4A5A5" strokeWidth="1" opacity="0.5" />
        
        {/* Floral center */}
        {[0, 60, 120, 180, 240, 300].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          return (
            <ellipse
              key={angle}
              cx={Math.cos(rad) * 40}
              cy={Math.sin(rad) * 40}
              rx="20"
              ry="12"
              fill="#C99090"
              opacity="0.5"
              transform={`rotate(${angle} ${Math.cos(rad) * 40} ${Math.sin(rad) * 40})`}
            />
          );
        })}
        <circle cx="0" cy="0" r="15" fill="#B88080" opacity="0.6" />
      </g>

      {/* Soft serif typography */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="serif" fontSize="10" fill="#B88080" fontStyle="italic">
        dentelle et grille
      </text>
    </g>
  );
}
